// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","pagination":"_3j_96","paginationButton":"_24mgv","previous":"_3RD4L","next":"_1RJF7","active":"_3F43Y"};